// extracted by mini-css-extract-plugin
module.exports = {"Checkbox":"checkbox_Checkbox__xKXXm","Box":"checkbox_Box__GrShH","BoxChecked":"checkbox_BoxChecked__lngbH"};